import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {
  GlameraIconBase,
  GlameraIconDefinition,
  GLAMERA_ICON_HOST_TEMPLATE,
} from '@glamera/animated-icons/core';

export const GLM_CHEVRON_RIGHT: GlameraIconDefinition = {
  name: 'chevron-right',
  viewBox: '0 0 24 24',
  svg: `
    <path class="glm-chevron-right-trail" d="m9 18 6-6-6-6"></path>
    <path class="glm-chevron-right-arrow" d="m9 18 6-6-6-6"></path>
  `.trim(),
};

@Component({
  standalone: true,
  selector: 'glamera-chevron-right-icon',
  template: GLAMERA_ICON_HOST_TEMPLATE,
  styleUrls: ['../../core/src/lib/base/icon-base.scss', './chevron-right.animation.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class ChevronRightIconComponent extends GlameraIconBase {
  readonly iconDef = GLM_CHEVRON_RIGHT;

  constructor(sanitizer: DomSanitizer, cdr: ChangeDetectorRef) {
    super(sanitizer, cdr);
  }
}
